(function() {
  // Get configuration from data attributes
  const sliderElement = document.querySelector('[data-testimonial-slider-id]');
  if (!sliderElement) return;
  
  const enableSlider = sliderElement.getAttribute('data-enable-slider') === 'true';
  const sectionId = sliderElement.getAttribute('data-section-id');
  const autoplayEnabled = sliderElement.getAttribute('data-autoplay-enabled') === 'true';
  const autoplaySpeed = parseFloat(sliderElement.getAttribute('data-autoplay-speed')) || 5;
  const trackElement = document.getElementById('marquee-track-' + sectionId);
   
  // Detect if device supports touch (mobile)
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  // Track if any video is currently playing (for marquee control)
  let isAnyVideoPlaying = false;
  
  // Function to pause marquee when video is playing
  const pauseMarqueeForVideo = function() {
    if (trackElement && autoplayEnabled && !isAnyVideoPlaying) {
      isAnyVideoPlaying = true;
      trackElement.classList.add('paused');
    }
  };
  
  // Function to resume marquee when video stops
  const resumeMarqueeForVideo = function() {
    // Check if any video is still playing
    const allVideos = sliderElement ? sliderElement.querySelectorAll('video') : [];
    
    const hasPlayingVideo = Array.from(allVideos).some(v => {
      return !v.paused;
    });
    
    if (!hasPlayingVideo && isAnyVideoPlaying) {
      isAnyVideoPlaying = false;
      if (trackElement && autoplayEnabled) {
        trackElement.classList.remove('paused');
      }
    }
  };
  
  // Initialize video hover and click functionality
  const initializeVideoHover = function(container) {
    const videoCards = container.querySelectorAll('.card-item.video-type');
    
    videoCards.forEach(card => {
      const video = card.querySelector('video');
      const overlay = card.querySelector('.video-overlay');
      // Look for thumbnail in media-wrapper or card
      const mediaWrapper = card.querySelector('.media-wrapper');
      const thumbnail = mediaWrapper ? mediaWrapper.querySelector('.video-thumbnail') : card.querySelector('.video-thumbnail');
      
      if (!video) return;
      
      // Initialize thumbnail visibility - show if video is paused (videos start paused)
      if (thumbnail) {
        thumbnail.style.opacity = '1';
        thumbnail.style.visibility = 'visible';
      }
      
      // Add video event listeners to control marquee and thumbnail
      video.addEventListener('play', function() {
        pauseMarqueeForVideo();
        // Hide thumbnail when video plays
        if (thumbnail) {
          thumbnail.style.opacity = '0';
          thumbnail.style.visibility = 'hidden';
        }
      });
      
      video.addEventListener('pause', function() {
        resumeMarqueeForVideo();
        // Show thumbnail when video pauses
        if (thumbnail) {
          thumbnail.style.opacity = '1';
          thumbnail.style.visibility = 'visible';
        }
      });
      
      video.addEventListener('ended', function() {
        resumeMarqueeForVideo();
        // Show thumbnail when video ends
        if (thumbnail) {
          thumbnail.style.opacity = '1';
          thumbnail.style.visibility = 'visible';
        }
      });
      
      // Function to play video
      const playVideo = function() {
        if (video && overlay) { 
          videoCards.forEach(otherCard => {
            if (otherCard !== card) {
              const otherVideo = otherCard.querySelector('video');
              const otherOverlay = otherCard.querySelector('.video-overlay');
              const otherMediaWrapper = otherCard.querySelector('.media-wrapper');
              const otherThumbnail = otherMediaWrapper ? otherMediaWrapper.querySelector('.video-thumbnail') : otherCard.querySelector('.video-thumbnail');
              if (otherVideo && !otherVideo.paused) {
                otherVideo.pause(); 
                if (otherOverlay) {
                  otherOverlay.style.opacity = '1';
                  otherOverlay.style.visibility = 'visible';
                }
                if (otherThumbnail) {
                  otherThumbnail.style.opacity = '1';
                  otherThumbnail.style.visibility = 'visible';
                }
              }
            }
          });

          // Ensure video is loaded before playing (important for mobile)
          if (video.readyState === 0) {
            video.load();
          }
          
          // Play current video
          const playPromise = video.play();
          
          if (playPromise !== undefined) {
            playPromise.then(() => {
              // Video started playing successfully - hide overlay and thumbnail
              if (overlay) {
                overlay.style.opacity = '0';
                overlay.style.visibility = 'hidden';
              }
              if (thumbnail) {
                thumbnail.style.opacity = '0';
                thumbnail.style.visibility = 'hidden';
              }
            }).catch(error => {
              // If play fails, show overlay and thumbnail again
              if (overlay) {
                overlay.style.opacity = '1';
                overlay.style.visibility = 'visible';
              }
              if (thumbnail) {
                thumbnail.style.opacity = '1';
                thumbnail.style.visibility = 'visible';
              }
            });
          } else {
            // Fallback for older browsers
            if (overlay) {
              overlay.style.opacity = '0';
              overlay.style.visibility = 'hidden';
            }
            if (thumbnail) {
              thumbnail.style.opacity = '0';
              thumbnail.style.visibility = 'hidden';
            }
          }
        }
      };
      
      // Function to pause video
      const pauseVideo = function() {
        if (video) {
          video.pause();
          if (overlay) {
            overlay.style.opacity = '1';
            overlay.style.visibility = 'visible';
          }
          if (thumbnail) {
            thumbnail.style.opacity = '1';
            thumbnail.style.visibility = 'visible';
          }
        }
      };
      
      // Desktop: Mouse hover events (ONLY for desktop, not mobile)
      if (!isTouchDevice) {
        card.addEventListener('mouseenter', function(e) {
          e.stopPropagation();
          playVideo();
        }, false);
        
        card.addEventListener('mouseleave', function(e) {
          e.stopPropagation();
          pauseVideo();
        }, false);
      }
      
      // Mobile: Click/touch events
      if (isTouchDevice) {
        // Use touchend for mobile (more reliable than click on mobile)
        card.addEventListener('touchend', function(e) {
          // Don't trigger if clicking the overlay button itself
          if (overlay && (e.target === overlay || overlay.contains(e.target))) {
            return;
          }
          
          e.preventDefault();
          e.stopPropagation();
          
          // Check actual video state
          if (video.paused) {
            playVideo();
          } else {
            pauseVideo();
          }
        }, { passive: false });
        
        // Also add click as fallback (for devices that support both)
        card.addEventListener('click', function(e) {
          // Don't trigger if clicking the overlay button itself
          if (overlay && (e.target === overlay || overlay.contains(e.target))) {
            return;
          }
          
          // Stop propagation to prevent delegation handler from interfering
          e.stopPropagation();
          
          // Check actual video state
          if (video.paused) {
            playVideo();
          } else {
            pauseVideo();
          }
        });
      }
      
      // Button click/keyboard events for accessibility (works on both mobile and desktop)
      if (overlay && overlay.tagName === 'BUTTON') {
        const handleOverlayClick = function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (video.paused) {
            playVideo();
          } else {
            pauseVideo();
          }
        };
        
        overlay.addEventListener('click', handleOverlayClick);
        
        // Also add touchend for mobile to ensure it works
        if (isTouchDevice) {
          overlay.addEventListener('touchend', function(e) {
            e.preventDefault();
            e.stopPropagation();
            handleOverlayClick(e);
          }, { passive: false });
        }
        
        // Handle keyboard events (Enter and Space)
        overlay.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (video.paused) {
              playVideo();
            } else {
              pauseVideo();
            }
          }
        });
      }
    });
  };
  
  // Initialize video hover for the container
  if (sliderElement) {
    initializeVideoHover(sliderElement);
  }
  
  if (!sliderElement || !enableSlider || !trackElement) {
    return;
  }
  
  // Get slides - needed for both autoplay and navigation
  const allSlides = trackElement.querySelectorAll('.marquee-slide');
  const totalSlides = allSlides.length;
  // Calculate original slides count (if slider enabled, first half are original, duplicates are second half)
  const originalSlidesCount = enableSlider ? Math.floor(totalSlides / 2) : totalSlides;
  
  if (autoplayEnabled) {
    // Calculate and setup seamless continuous marquee animation
    
    // Function to calculate original slides width and setup animation
    const setupMarqueeAnimation = function() {
      if (allSlides.length === 0 || originalSlidesCount === 0) return;
      
      // Calculate total width of original slides (first half) including margins
      let originalWidth = 0;
      let cardWidth = 0; // Store first card width for speed calculation
      
      for (let i = 0; i < originalSlidesCount; i++) {
        const slide = allSlides[i];
        if (!slide) continue;
        
        const slideRect = slide.getBoundingClientRect();
        const slideWidth = slideRect.width;
        
        // Store first card width for speed calculation
        if (i === 0) {
          cardWidth = slideWidth;
        }
        
        // Get margin-right (default 20px from CSS)
        const computedStyle = window.getComputedStyle(slide);
        const marginRight = parseFloat(computedStyle.marginRight) || 20;
        
        originalWidth += slideWidth + marginRight;
      }
      
      // Only proceed if we have a valid width
      if (originalWidth > 0 && cardWidth > 0) {
        // Set CSS variable for animation offset (exact width of original slides)
        trackElement.style.setProperty('--marquee-offset', '-' + originalWidth + 'px');
        
        // Calculate animation duration based on constant speed
        // Speed setting (3-10s) represents time to move one card width
        // So duration = (total_width / card_width) * speed_setting
        // This ensures consistent speed regardless of number of blocks
        const animationDuration = (originalWidth / cardWidth) * autoplaySpeed;
        trackElement.style.animationDuration = animationDuration + 's';
        
        // Add animate class to start animation immediately
        trackElement.classList.add('animate');
      }
    };
    
    // Setup animation immediately - try multiple times to ensure it starts
    // First attempt - immediate
    setupMarqueeAnimation();
    
    // Second attempt - next frame (ensures DOM is ready)
    requestAnimationFrame(function() {
      setupMarqueeAnimation();
    });
    
    // Third attempt - after a short delay (for images/rendering)
    setTimeout(function() {
      setupMarqueeAnimation();
    }, 50);
    
    // Final attempt - after full page load (for accurate measurements)
    if (document.readyState === 'complete') {
      setTimeout(setupMarqueeAnimation, 150);
    } else {
      window.addEventListener('load', function() {
        setTimeout(setupMarqueeAnimation, 150);
      });
    }
    
    // Recalculate on window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(setupMarqueeAnimation, 250);
    });
    
    // Function to pause all playing videos
    const pauseAllVideos = function() {
      const allVideos = sliderElement.querySelectorAll('video');
      
      allVideos.forEach((video) => {
        if (!video.paused) {
          video.pause();
          
          // Show overlay and thumbnail if they exist
          const card = video.closest('.card-item');
          if (card) {
            const overlay = card.querySelector('.video-overlay');
            const mediaWrapper = card.querySelector('.media-wrapper');
            const thumbnail = mediaWrapper ? mediaWrapper.querySelector('.video-thumbnail') : card.querySelector('.video-thumbnail');
            if (overlay) {
              overlay.style.opacity = '1';
              overlay.style.visibility = 'visible';
            }
            if (thumbnail) {
              thumbnail.style.opacity = '1';
              thumbnail.style.visibility = 'visible';
            }
          }
        }
      });
    };
    
    // Function to manually resume marquee (only if no videos are playing)
    // If forceResume is true, it will pause all videos first, then resume marquee
    const manualResumeMarquee = function(forceResume) {
      if (!trackElement || !autoplayEnabled) {
        return;
      }
      
      // If forceResume is true (clicking outside), pause all videos first
      if (forceResume === true) {
        pauseAllVideos();
      }
      
      // Check if any video is currently playing
      const allVideos = sliderElement.querySelectorAll('video');
      const hasPlayingVideo = Array.from(allVideos).some(v => {
        return !v.paused && v.readyState > 0;
      });
      
      // Only resume if no videos are playing
      if (!hasPlayingVideo) {
        isAnyVideoPlaying = false;
        trackElement.classList.remove('paused');
      }
    };
    
    // Use event delegation - resume marquee if click is NOT on/in a video card
    document.addEventListener('click', function(e) {
      const isInsideSlider = sliderElement.contains(e.target);
      const clickedVideoCard = e.target.closest('.card-item.video-type');
      
      // If NOT clicked on/in a video card, resume marquee
      if (!clickedVideoCard) {
        const clickedCard = e.target.closest('.card-item');
        
        if (clickedCard && isInsideSlider) {
          pauseAllVideos();
          manualResumeMarquee(false);
        } else if (isInsideSlider) {
          manualResumeMarquee(true);
        } else {
          manualResumeMarquee(true);
        }
      }
    }, false);
    
    // Also add touchstart for mobile devices
    if (isTouchDevice) {
      document.addEventListener('touchstart', function(e) {
        const isInsideSlider = sliderElement.contains(e.target);
        const touchedVideoCard = e.target.closest('.card-item.video-type');
        
        // If NOT touched on/in a video card, resume marquee
        if (!touchedVideoCard) {
          const touchedCard = e.target.closest('.card-item');
          
          if (touchedCard && isInsideSlider) {
            pauseAllVideos();
            manualResumeMarquee(false);
          } else if (isInsideSlider) {
            manualResumeMarquee(true);
          } else {
            manualResumeMarquee(true);
          }
        }
      }, { passive: true });
    }
    
    // Note: Marquee pause/resume is controlled by:
    // 1. Video playback state (auto pause/resume)
    // 2. Clicking on non-video cards (manual resume)
    // 3. Clicking outside cards (manual resume)
  }
})();

